export const InActiveStyle = {
  color: "red",
};
